module.exports = {
	buttons: {
		centrify: true,
	},
	companyName: 'Inogen Connect',
	company: 'Inogen',
	siteTitle: 'Inogen Connect Portal',
	copyRight: `Inogen ${new Date().getFullYear()}`,
};
